import clsx from 'clsx';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import ToggleIcon from '../../assets/icons/sidebar-toggle-icon.svg?react';
import { toggleSwitch } from '../../reducers/switch';
import Pagination from '../../components/CustomPagination';
import ArrowRightIcon from '../../assets/icons/arrow-right.svg?react';
import moment from 'moment';
import Button from '../../components/Button';
import { useButtonSizeLarge } from '../../utils/buttonSizes';
import { FormikProps } from 'formik';
import { toggleModal } from '../../reducers/modalToggle';
export interface BulkUserFormValues {
  file: File[];
  userRecords?: Array<{
    employeeId: string;
    fullName: string;
    email: string;
    contactNumber: string;
    dateOfBirth: string;
    department: string;
    jobTitle: string;
    role: string;
  }>;
}
interface BulkUserCreationStepThreeProps {
  otherClasses?: string;
  formHandler: FormikProps<BulkUserFormValues>;
  roles: {
    label: string;
    value: string;
  }[];
  departments: {
    label: string;
    value: string;
  }[];
  handleSteps: (step: number) => void;
}

const BulkUserCreationStepThree: React.FC<BulkUserCreationStepThreeProps> = ({
  otherClasses,
  formHandler,
  roles,
  departments,
  handleSteps,
}) => {
  const bulkUserCreationStepThreeClasses = clsx(otherClasses);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const lg = useButtonSizeLarge();

  return (
    <div
      className={bulkUserCreationStepThreeClasses}
      data-testid="bulk-user-creation-step-three"
    >
      <div>
        <div className="flex items-center gap-2.5">
          <button
            type="button"
            className="bg-translucent-background/80 border-neutral-tones-text/30 rounded-5 cursor-pointer border p-0.5 lg:hidden"
            onClick={() => dispatch(toggleSwitch())}
          >
            <ToggleIcon />
          </button>
          <h1 className="h3">Review Details</h1>
        </div>
      </div>
      <div className="rounded-10 bg-card-backgrounds/5 border-neutral-tones-text/10 mt-12 w-full border px-15 pt-15">
        <h5 className="text-brand-byzantine font-inter-variable text-xl font-bold">
          Employees Details
        </h5>
        <div className="global-scrollbar-style w-full overflow-auto px-1 pt-9 pb-15">
          <div className="min-w-7xl">
            <div className="border-neutral-tones-text/10 grid grid-cols-9 gap-3 border-b pb-5">
              <h6 className="font-inter-variable text-neutral-tones-text text-lg leading-5 font-bold">
                Employee ID
              </h6>
              <h6 className="font-inter-variable text-neutral-tones-text text-lg leading-5 font-bold">
                Full Name
              </h6>
              <h6 className="font-inter-variable text-neutral-tones-text text-lg leading-5 font-bold">
                Email
              </h6>
              <h6 className="font-inter-variable text-neutral-tones-text text-lg leading-5 font-bold">
                Number
              </h6>
              <h6 className="font-inter-variable text-neutral-tones-text text-lg leading-5 font-bold">
                Date of Birth
              </h6>
              <h6 className="font-inter-variable text-neutral-tones-text text-lg leading-5 font-bold">
                Date of Hire
              </h6>
              <h6 className="font-inter-variable text-neutral-tones-text text-lg leading-5 font-bold">
                Department
              </h6>
              <h6 className="font-inter-variable text-neutral-tones-text text-lg leading-5 font-bold">
                Job Title
              </h6>
              <h6 className="font-inter-variable text-neutral-tones-text text-lg leading-5 font-bold">
                Role
              </h6>
            </div>
            {formHandler?.values?.userRecords
              ?.slice((currentPage - 1) * 10, currentPage * 10)
              .map((node: any, index: number) => {
                return (
                  <div
                    key={index}
                    className="border-neutral-tones-text/10 mt-5 grid grid-cols-9 gap-3 border-b pb-5"
                  >
                    <p className="font-inter-variable text-neutral-tones-text truncate text-lg leading-5 font-normal">
                      {node?.employeeId}
                    </p>
                    <p className="font-inter-variable text-neutral-tones-text truncate text-lg leading-5 font-normal">
                      {node?.fullName}
                    </p>
                    <p className="font-inter-variable text-neutral-tones-text truncate text-lg leading-5 font-normal">
                      {node?.email}
                    </p>
                    <p className="font-inter-variable text-neutral-tones-text truncate text-lg leading-5 font-normal">
                      {node?.contactNumber}
                    </p>
                    <p className="font-inter-variable text-neutral-tones-text truncate text-lg leading-5 font-normal">
                      {node?.dateOfBirth && moment(node.dateOfBirth).isValid()
                        ? moment(node.dateOfBirth).format('MMM DD, YYYY')
                        : ''}
                    </p>
                    <p className="font-inter-variable text-neutral-tones-text truncate text-lg leading-5 font-normal">
                      {node?.dateOfHire && moment(node.dateOfHire).isValid()
                        ? moment(node.dateOfHire).format('MMM DD, YYYY')
                        : ''}
                    </p>
                    <p className="font-inter-variable text-neutral-tones-text truncate text-lg leading-5 font-normal">
                      {
                        departments.find(
                          (department) => department.value === node?.department,
                        )?.label
                      }
                    </p>
                    <p className="font-inter-variable text-neutral-tones-text truncate text-lg leading-5 font-normal">
                      {node?.jobTitle}
                    </p>
                    <p className="font-inter-variable text-neutral-tones-text truncate text-lg leading-5 font-normal">
                      {roles.find((role) => role.value === node?.role)?.label}
                    </p>
                  </div>
                );
              })}
          </div>
        </div>
        {(formHandler?.values?.userRecords || [])?.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(
              (formHandler?.values?.userRecords || [])?.length / 10,
            )}
            totalItems={(formHandler?.values?.userRecords || [])?.length}
            limit={10}
            showingItems={
              (formHandler?.values?.userRecords || [])?.slice(
                (currentPage - 1) * 10,
                currentPage * 10,
              )?.length
            }
            onPageChange={(page) => setCurrentPage(page)}
            otherClasses="!pb-15 pt-8"
            hiddenCombobox
          />
        )}
      </div>
      <div className="mt-10 flex items-center justify-center gap-6 lg:justify-between">
        <Button
          size={lg}
          type="button"
          variant="secondary"
          onClick={() => handleSteps(2)}
          otherClasses="w-full sm:w-150"
          disable={formHandler?.isSubmitting}
        >
          <ArrowRightIcon className="h-6 w-6 rotate-180 [&>g>path]:fill-current" />
          Back
        </Button>
        <Button
          size={lg}
          type="button"
          onClick={() => dispatch(toggleModal('bulk-user-upload-confirmation-modal'))}
          otherClasses="w-full sm:w-150"
        >
          Submit <ArrowRightIcon className="h-6 w-6 [&>g>path]:fill-current" />
        </Button>
      </div>
    </div>
  );
};

export default BulkUserCreationStepThree;
